export default __webpack_public_path__ + "static/media/lock.7c0c01a8.svg";